import { render, staticRenderFns } from "./ForceReadPufaOnlineAuthPufaStatementUse.vue?vue&type=template&id=0cb8763a&scoped=true"
import script from "./ForceReadPufaOnlineAuthPufaStatementUse.vue?vue&type=script&lang=js"
export * from "./ForceReadPufaOnlineAuthPufaStatementUse.vue?vue&type=script&lang=js"
import style0 from "./ForceReadPufaOnlineAuthPufaStatementUse.vue?vue&type=style&index=0&id=0cb8763a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8763a",
  null
  
)

export default component.exports